import { useCallback, useEffect, useState } from "react";

const DEFAULT_FEEDBACK_DURATION_MS = 1000;

export type UseCopiedNotificationOptions = {
    duration?: number;
};

type UseCopiedNotificationReturn = {
    isCopied: boolean;
    onCopy: () => void;
};

export const useCopiedNotification = (options?: UseCopiedNotificationOptions): UseCopiedNotificationReturn => {
    const { duration = DEFAULT_FEEDBACK_DURATION_MS } = options ?? {};
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        if (!isCopied) {
            return;
        }

        const timeoutId = setTimeout(() => {
            setIsCopied(false);
        }, duration);

        return () => clearTimeout(timeoutId);
    }, [isCopied, duration]);

    const onCopy = useCallback(() => {
        setIsCopied(true);
    }, []);

    return { isCopied, onCopy };
};
